import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsPage } from "@/features/integrations/integrations-page";

export const Route = createFileRoute("/_authenticated/integrations/")({
  head: () => ({ meta: [{ title: "Integrations · Rogue Admin" }] }),
  component: IntegrationsPage,
});
